// extracted by mini-css-extract-plugin
export default {"container":"globalMessage_container__4OV71","ok":"globalMessage_ok__DyEs5","error":"globalMessage_error__1I6I8"};